export default "__VITE_ASSET__7b732d89__"